import { Match, mergeProps, Switch } from 'solid-js';
import { EApplicationType } from '~/api';
import { Localized } from '~/i18n';
import { getTranslationKey } from './utils';
import { externalLinks } from '~/consts';
import Link from '~/components/Link';
import { SquareArrowOutUpRight } from 'lucide-solid';

type MultiAppDocsLinksProps = {
  applicationType: EApplicationType;
};

export default function MultiAppDocsLinks(props: MultiAppDocsLinksProps) {
  const merged = mergeProps({}, props);

  const getSubheaderComponent = (translationKey: string, href: string) => {
    return (
      <div class="flex items-center gap-2">
        <Localized translationKey={translationKey} />
        <Link
          href={href}
          target="_blank"
          class="flex items-center gap-1 text-sm text-link-primary"
          data-testid="multi-app-learn-more-link"
          rel="noopener noreferrer"
        >
          <Localized translationKey={getTranslationKey('learn_more')} />
          <SquareArrowOutUpRight
            width={14}
            height={14}
          />
        </Link>
      </div>
    );
  };

  return (
    <Switch>
      <Match
        when={merged.applicationType === EApplicationType.DEFAULT_APPLICATION}
      >
        {getSubheaderComponent(
          getTranslationKey('web_application_subheader'),
          externalLinks.multiApplicationsLinks.webApplication
        )}
      </Match>
      <Match when={merged.applicationType === EApplicationType.WEB_APPLICATION}>
        {getSubheaderComponent(
          getTranslationKey('web_application_subheader'),
          externalLinks.multiApplicationsLinks.webApplication
        )}
      </Match>
      <Match
        when={
          merged.applicationType === EApplicationType.SINGLE_PAGE_APPLICATION
        }
      >
        {getSubheaderComponent(
          getTranslationKey('single_page_application_subheader'),
          externalLinks.multiApplicationsLinks.singlePageApplication
        )}
      </Match>
      <Match
        when={merged.applicationType === EApplicationType.NATIVE_APPLICATION}
      >
        {getSubheaderComponent(
          getTranslationKey('native_application_subheader'),
          externalLinks.multiApplicationsLinks.nativeApplication
        )}
      </Match>
    </Switch>
  );
}
